import { useState } from "react";
import { FaFileAlt } from "react-icons/fa";
import Modal from "../common/Modal";

const documents = [
  { title: "AML Policies & Procedure", file: "AML Policies & Procedures.pdf" },
  { title: "Risk Disclosure", file: "risk-disclosure.pdf" },
  { title: "Terms & Conditions", file: "terms-conditions.pdf" },
  { title: "Client Complaint handling", file: "client-complaint.pdf" },
  { title: "Client Agreement", file: "client-agreement.pdf" },
  { title: "Cookies Policy", file: "cookies-policy.pdf" },
  { title: "Privacy Policy", file: "privacy-policy.pdf" },
  { title: "Introduces broker Agreement", file: "introducer-agreement.pdf" },
  { title: "Appropriate Warning", file: "appropriate-warning.pdf" },
  { title: "Conflict Policy", file: "conflict-policy.pdf" },
  { title: "Execution Policy", file: "execution-policy.pdf" },
];

export default function LegalDocuments() {
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [showViewer, setShowViewer] = useState(false);

  const openViewer = (doc) => {
    setSelectedDoc(doc);
    setShowViewer(true);
  };

  const closeViewer = () => {
    setShowViewer(false);
    setSelectedDoc(null);
  };

  const pdfUrl = selectedDoc ? `/docs/${selectedDoc.file}` : null;

  return (
    <div className="w-full p-6">
      <div className="space-y-3">
        <h2 className="text-2xl font-semibold mb-4">Legal Documents</h2>

        <ul className="space-y-2">
          {documents.map((doc, idx) => (
            <li
              key={idx}
              className={`cursor-pointer p-3 rounded border w-full ${selectedDoc?.file === doc.file
                  ? "bg-red-100 border-red-400"
                  : "bg-white hover:bg-gray-100 border-gray-300"
                }`}
              onClick={() => openViewer(doc)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") openViewer(doc);
              }}
            >
              <div className="flex items-center justify-between gap-3">
                <span className="font-medium">{doc.title}</span>
                <span className="inline-flex items-center gap-2 text-sm text-gray-500">
                  <FaFileAlt className="h-4 w-4 text-primary" aria-hidden="true" />
                  <span>View PDF</span>
                </span>
              </div>
            </li>
          ))}
        </ul>
      </div>

      {showViewer && selectedDoc && (
        <Modal
          message={selectedDoc.title}
          onClose={closeViewer}
          maxWidthClass="max-w-5xl"
        >
          <div className="w-full h-[70vh]">
            <iframe
              src={pdfUrl}
              title={selectedDoc.title}
              className="w-full h-full"
            />
          </div>
        </Modal>
      )}
    </div>
  );
}
